import { HTTPFetchNetworkInterface } from 'apollo-client';

export default class GraphQLNetworkInterface extends HTTPFetchNetworkInterface {
  setUri(uri) {
    this._uri = uri;
  }
}
